import { useRouter } from 'next/router'
import cn from 'classnames'

import { Button } from '@components/Buttons'
import { ArrowLeftIcon } from '@components/icons/ArrowLeftIcon'
import { ArrowRightIcon } from '@components/icons/ArrowRightIcon'
import { PrevNextSectionProps } from './interface'

export function PrevNextSection({
  className,
  prevUrl,
  nextUrl,
  isDarkTheme,
  isLightOrSepiaTheme,
  disableNext,
  disablePrev,
}: PrevNextSectionProps) {
  const router = useRouter()

  return (
    <div
      className={cn(
        'flex justify-between py-[50px] mobile:py-[30px] mobile:space-x-[20px]',
        className,
        {
          'text-white': !isDarkTheme,
          '!text-gray-16': isDarkTheme,
        }
      )}
    >
      <Button
        type='button'
        className={cn(
          'border bg-transparent dark:text-dark-10 dark:border-dark-10 h-[40px] mobile:w-[40px] mobile:rounded-full',
          {
            'border-gray-3 text-secondary-1': isLightOrSepiaTheme,
            '!border-gray-16 !text-gray-16': isDarkTheme,
          }
        )}
        disabled={disablePrev}
        onClick={() => router.push(prevUrl)}
      >
        <div className='flex items-center text-sm space-x-[5px]'>
          <ArrowLeftIcon width='24' height='24' />
          <span className='mobile:hidden'>ตอนก่อนหน้า</span>
        </div>
      </Button>

      <Button
        type='button'
        className={cn('border h-[40px] mobile:w-full', {
          'border-primary dark:border-purple bg-primary dark:bg-purple':
            !isDarkTheme,
          'border-dark-4 bg-dark-4': isDarkTheme,
        })}
        disabled={disableNext}
        onClick={() => router.push(nextUrl)}
      >
        <div className='flex items-center text-sm space-x-[5px]'>
          ตอนต่อไป
          <ArrowRightIcon width='24' height='24' />
        </div>
      </Button>
    </div>
  )
}
